<template>
  <span>
    <v-text-field
      :label="i18n.account_search"
      outlined
      dense
      hide-details
      :loading="loading"
      :class="`${arabic?'arFont':'enFont'}`"
      v-model="search_object.search"
      @keydown.enter="search"
    >
    </v-text-field>
    <v-btn block text color="primary" @click="search()" :class="`${arabic?'arFont':'enFont'} mt-1`" x-small>{{i18n.search}}</v-btn>
  </span>
</template>

<script>
export default {
  props:['loading', 'search_object'],
  methods:{
    search(){
      this.$emit('searchAccounts')
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
}
</script>

<style>

</style>